import React from 'react';
import Sidebar from './Sidebar';
import ServerMonitor from './ServerMonitor';
import { Toaster } from './ui/sonner';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      <div className="noise-overlay" />
      <ServerMonitor />
      <Sidebar />
      <main className="lg:ml-64 pt-16 lg:pt-0 min-h-screen">
        <div className="p-4 sm:p-6 lg:p-8">
          {children}
        </div>
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default Layout;
